type ReferenceNumber = {
  reference: string | undefined;
  displayReference?: boolean;
};

export const ConfirmationBanner: React.FunctionComponent<ReferenceNumber> = (
  props: ReferenceNumber,
) => {
  const displayReference = props?.displayReference ?? true;
  return (
    <section className="flex flex-col gap-y-14 rounded bg-[#0025B9] px-6 py-12 text-white md:px-12 lg:px-12 xl:px-12">
      <section className="text-[53px] font-semibold leading-none">
        Your report has been submitted
      </section>
      <section className="flex flex-col gap-y-3">
        {displayReference && (
          <>
            <div className="text-xl">Your reference number</div>
            <div className="text-[41px] font-semibold leading-normal underline decoration-2 underline-offset-4">
              {props.reference}
            </div>
          </>
        )}
      </section>
    </section>
  );
};
